import { render, staticRenderFns } from "./shicibackup.vue?vue&type=template&id=dbaad234&scoped=true"
import script from "./shicibackup.vue?vue&type=script&lang=js"
export * from "./shicibackup.vue?vue&type=script&lang=js"
import style0 from "./shicibackup.vue?vue&type=style&index=0&id=dbaad234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbaad234",
  null
  
)

export default component.exports